import { usePcpApiMethods } from "live-lesson/shared/feature-call-ui-react";
import { useChatThreadClient } from "@azure/communication-react";
import React from "react";

/**
 * Hook to clear the current chat thread.
 * It uses the `pcpApi` to clear the chat thread and manages the loading state.
 *
 * Note:
 * It will always clear the chat thread which is currently provided by the `ChatThreadClientProvider`.
 *
 * @returns {Object} - An object containing the loading state and a function to clear the chat thread.
 */
export function useClearThread() {

    const pcpApi = usePcpApiMethods();
    const chatThreadClient = useChatThreadClient();

    const [isClearing, setIsClearing] = React.useState(false);
    const clearCurrentChatThread = React.useCallback(async () => {
        if (isClearing) {
            return;
        }
        setIsClearing(true);
        try {
            await pcpApi.clearChat(chatThreadClient.threadId);
        } finally {
            setIsClearing(false);
        }
    }, [isClearing, pcpApi, chatThreadClient.threadId]);
    return { isClearing, clearCurrentChatThread };
}
